import { useQuery } from '@tanstack/react-query'

import { FetchStaff } from '@/services/StaffService'

/** Every staff member an organization has, as the list shape. */
export const useStaff = (orgId: string) => {
  return useQuery({
    queryKey: ['staff', orgId],
    queryFn: () => FetchStaff(orgId),
    enabled: Boolean(orgId),
  })
}
